/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpecificOrganisation
 */
export interface SpecificOrganisation {
    /**
     * 
     * @type {string}
     * @memberof SpecificOrganisation
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificOrganisation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificOrganisation
     */
    adminEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificOrganisation
     */
    code?: string;
}

/**
 * Check if a given object implements the SpecificOrganisation interface.
 */
export function instanceOfSpecificOrganisation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SpecificOrganisationFromJSON(json: any): SpecificOrganisation {
    return SpecificOrganisationFromJSONTyped(json, false);
}

export function SpecificOrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpecificOrganisation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'adminEmail': !exists(json, 'adminEmail') ? undefined : json['adminEmail'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function SpecificOrganisationToJSON(value?: SpecificOrganisation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'adminEmail': value.adminEmail,
        'code': value.code,
    };
}

